<template>
  <div class="base-container" v-loading="loading">
    <nav-header v-if="!isFullScreen"></nav-header>
    <license-content v-if="licenseShow"></license-content>
    <div class="homeContainer" id="home"></div>
  </div>
</template>
<script>
import { setDefaultMountApp, start, registerMicroApps } from "qiankun";
import { to } from "await-to-js";
import {
  isEmpty,
  contains,
  indexOfContains,
  getRealPath,
} from "@/utils/utils.js";
import { contactSocket, webSocket, clearTimer } from "@/utils/wsUtils.js";
import { initState as globalState } from "@/store/shardActions";
import NavHeader from "./components/NavHeader.vue";
import LicenseContent from "./components/LicenseContent.vue";

export default {
  watch: {
    "$store.state.config.dataUpdate"(newVal) {
      if (newVal == "dataUpdate") {
        this.dateUpdateDo();
      } else if (newVal == "baseInfo") {
        this.getWorkBench();
      }
      this.$store.commit("config/dataUpdate", "");
    },
    $route: {
      handler() {
        this.$nextTick(() => {
          this.isFullScreen = this.dealFullScreen();
        });
      },
    },
  },

  components: {
    NavHeader,
    LicenseContent,
  },
  computed: {
    pluginsConfig() {
      return window.HS_CONFIG.basePluginsConfig;
    },
  },

  data() {
    return {
      timer: null,
      licenseShow: false,
      isFullScreen: true,
      loading: false,
    };
  },

  created() {
    this.getAllInfo();
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (!isEmpty(webSocket)) {
      try {
        webSocket.close();
        webSocket = {};
      } catch (err) {
        // console.log(err)
      } finally {
        clearTimer();
      }
    }
  },

  methods: {
    async getAllInfo() {
      this.loading = true;
      const res= await this.getWorkBench();
      if(!res){
        this.licenseShow = true;
        await this.getInsertBasePlugins();
        contactSocket();
        this.startApp();
        this.loading = false;
        this.isFullScreen = this.dealFullScreen();
      }
    },

    async dateUpdateDo() {
      await this.getWorkBench();
      await this.getInsertBasePlugins();
    },

    async getWorkBench() {
      const [err, data] = await to(this.$httpList.getWorkBench());
      if (err) {
        // console.log(err);
        return new Promise.reject("false");;
      }
      const resData = data.data;
      let permissionTree = {};
      if (data.resultCode == 1001 && resData.permissionTree) {
        // permissionTree = resData.permissionTree;
        //去掉不用的属性
        if (!Object.keys(resData.permissionTree).length) {
          this.loginOutTodo("loginPromptMessage.noPermission");
          return new Promise.reject("noPermission");
        }
        Object.keys(data.data.permissionTree).forEach((key) => {
          permissionTree[key] = this.dealPermissionTree(
            resData.permissionTree[key]
          );
        });
      } else {
        //无法正常获取到permission或者workenbech接口请求异常，退出
        this.loginOutTodo("loginPromptMessage.noPermission");
        return new Promise.reject("noPermission");
      }
      //处理无app, domain情况
      this.dealApps(resData.apps);
      if (!resData.user.domains) {
        this.loginOutTodo("loginPromptMessage.noCustomer");
        return new Promise.reject("noCustomer");
      }
      this.$store.commit("config/setUserInfo", resData.user);
      let terminalData = resData.data || [];
      terminalData.forEach((item) => {
        if (item.terminals && item.terminals.length) {
          item.terminals.sort((a, b) => {
            return a.terminal > b.terminal ? 1 : -1;
          });
        }
      });
      this.$actions.setGlobalState({
        commonData: {
          customer: resData.customers,
          username: resData.username,
          userId: resData.userId,
          data: terminalData,
        },
        currentUser: resData.user,
        permissionTree,
      });
      //设置选中门店
      this.orgTerminalInit();

      this.userLoginNeedDo();

      if (permissionTree["All-Star"] && permissionTree["All-Star"].length) {
        this.dealPermissionAboutAs(permissionTree["All-Star"]);
      }
      //无选中app时，默认选择as
      let setAppName = globalState.currentAppName || "All-Star";

      let setApp = this.$store.state.config.apps.find(
        (item) => item?.appName.toLowerCase() == setAppName.toLowerCase()
      );
      if (!setApp) {
        setApp = this.$store.state.config.apps[0];
      }
      const internalAppIcons=['all-star','assetmanager','fe','mars','mapserver','aurora','prismart','template','plugin@saas-subscribe','feature'];
      let appIcon=null
      if(setApp?.appName){
        if(internalAppIcons.indexOf(setApp.appName.toLowerCase())!=-1){
          appIcon=require(`@/assets/home/${setApp.appName.toLowerCase()}.png`);
        }else{
          appIcon=setApp?.icon
        }
      }
      this.$actions.setGlobalState({ currentAppName: setApp?.appName,currentAppIcon:appIcon });
      if(!isEmpty(setApp.activeRule)){
        setDefaultMountApp(setApp.activeRule[0]);
      }
      let needRegisterApp = this.$store.state.config.apps.filter(
        (item) => item.activeRule
      );
      registerMicroApps(needRegisterApp, {
        beforeLoad: (app) => console.log("before load", app.name),
        beforeMount: (app) => {
          if (globalState.currentAppName != app.appName) {
            let src=app.icon;
            if(internalAppIcons.indexOf(app.appName.toLowerCase())!=-1){
              src=require(`@/assets/home/${app.appName.toLowerCase()}.png`)
            }
            this.$actions.setGlobalState({
              currentAppName: app.appName,
              currentAppIcon: src
            });
          }
        },
        beforeUnmount: (app) => console.log("unmount", app.name),
      });
    },

    async getInsertBasePlugins() {
      const [err, res] = await to(this.$httpList.getRunningPluginInfo());
      if (err) {
        console.log(err);
        return;
      }
      if (res.resultCode == 1001) {
        // const isProduction = process.env.NODE_ENV === "production";
        let plugins = res.data.filter(
          (item) =>
            item?.status?.toLowerCase() == "installed" &&
            item.mode &&
            item.mode == "Portal"
        );
        if (!plugins.length || !this.$store.state.config.hasAsPermission) {
          return;
        }
        let pluginPermissions = [];
        this.$store.state.config.asPermissionTree.forEach((item) => {
          if (contains(item.permsCode, "Plugins@")) {
            pluginPermissions.push(item);
          }
        });
        let pluginPermissionPluginIds = pluginPermissions.map((item) =>
          this.getPluginIdFromPermission(item.permsCode)
        );
        if (!plugins.length) {
          return;
        }
        plugins = plugins.map((item) => {
          return {
            appName: "Plugin@" + item.pluginId,
            name: "Plugin@" + item.pluginId,
            //TODO 后续排查为什么不能用mounted的props 无问题删除
            props: {
              getGlobalState: this.$actions.getGlobalState,
              baseRouter: `/${item.pluginId}`,
              permissions: pluginPermissions.filter((pers) =>
                indexOfContains(pers.permsCode, `Plugins@${item.pluginId}@`)
              ),
            },
            container: "#home",
            entry: `${getRealPath()}/static-plugin/${item.pluginId}/static`,
            activeRule: "#/" + item.pluginId,
            icon: pluginPermissions.find((pers) =>
              indexOfContains(pers.permsCode, `Plugins@${item.pluginId}@`)
            )?.icon,
          };
        });

        plugins = plugins.filter((item) =>
          pluginPermissionPluginIds.includes(
            item.appName.replace("Plugin@", "")
          )
        );
        this.$store.commit("config/setPlugins", plugins);
        registerMicroApps(plugins, {
          beforeLoad: (app) => console.log("before plugin load", app.name),
          beforeMount: (app) => {
            if (globalState.currentAppName != app.appName) {
              let src=app.icon;
              if(internalAppIcons.indexOf(app.appName.toLowerCase())!=-1){
                src=require(`@/assets/home/${app.appName.toLowerCase()}.png`)
              }
              this.$actions.setGlobalState({
                currentAppName: app.appName,
                currentAppIcon: src
              });
            }
          },
          beforeUnmount: (app) => console.log("unmount plugin", app.name),
        });
      }
    },

    userLoginNeedDo() {
      //  语言偏好设置
      if (
        !this.$actions.getGlobalState("loginFlag") &&
        this.$store.state.config.userInfo.languagePreference
      ) {
        let language = this.$store.state.config.languageList.find(
          (lang) =>
            lang.code == this.$store.state.config.userInfo.languagePreference
        );
        this.$i18n.locale = language ? language.code : "en";
        this.$actions.setGlobalState({
          currentLanguage: language ? language.code : "en",
        });
      }
      this.$actions.setGlobalState({ loginFlag: true });
    },

    dealPermissionTree(tree = []) {
      const res = [];
      tree.forEach((item) => {
        //link, appId, createTime, extend, updateTime
        const {
          childNodes = [],
          applicationName,
          permsCode,
          realm,
          type,
          i18n,
          orderNum,
          icon
        } = item;
        const tmp = {
          childNodes,
          applicationName,
          permsCode,
          realm,
          type,
          i18n,
          orderNum,
          icon
        };
        if (tmp.childNodes.length) {
          tmp.childNodes = this.dealPermissionTree(tmp.childNodes);
        }
        res.push(tmp);
      });
      return res;
    },

    dealPermissionAboutAs(asPermissions = []) {
      this.$store.commit("config/hasAsPermission", true);
      this.$store.commit("config/setAsPermissionTree", asPermissions);
      // 管理权限
      const manageFlag = asPermissions.some((item) =>
        ["SYSTEM", "GLOBAL"].includes(item.realm)
      );
      // 业务权限
      const serviceFlag = asPermissions.some((item) =>
        ["ADMIN", "OPERATOR"].includes(item.realm)
      );
      if (manageFlag && serviceFlag) {
        this.$store.commit("config/hasServicePage", true);
      } else {
        this.$actions.setGlobalState({ servicePage: serviceFlag });
      }
    },

    dealApps(apps = []) {
      if (!apps.length) {
        this.loginOutTodo("loginPromptMessage.noPermission");
        return new Promise.reject("noPermission");
      }
      let dealApps = apps.map((item) => {
        if (item.appType && item.appType == "Template") {
          item.newWindow = true;
        }
        item.name = item.webRoot;
        item.props = {};
        item.props.getGlobalState = this.$actions.getGlobalState;
        item.props.gateway = `/proxy/${item.webRoot}`;
        item.container = "#home";
        return item;
      });
      dealApps = dealApps.filter((app) => {
        if (app.appType == "Template") {
          return true;
        } else {
          return app.activeRule && app.appType && app.entry;
        }
      });
      const manageApps=dealApps.filter(app=>app.managePageShow)
      if(manageApps.length){
        this.$store.commit('config/setManageApps',manageApps.map(obj=>obj.appName));
      }
      if (process.env.NODE_ENV == "development") {
        dealApps = this.devAppendApp(dealApps);
      }

      this.$store.commit("config/setApps", dealApps);
    },

    devAppendApp(dealApps = []) {
      const apps = window.HS_CONFIG.basePluginsConfig || [];
      if (apps.length) {
        apps.forEach((app) => {
          let hasApp = dealApps.find((item) => item.appName == app.appName);
          if (hasApp) {
            hasApp.entry = app.entry;
          } else {
            let pushApp = {
              name: app.name,
              appName: app.appName,
              entry: app.entry,
              gateway: app.gateway,
              props: {},
              webRoot: app.webRoot,
              container: "#home",
              activeRule: app.activeRule,
            };
            pushApp.props.getGlobalState = this.$actions.getGlobalState;
            dealApps.push(pushApp);
          }
        });
      }
      return dealApps;
    },

    loginOutTodo(message = "", content = "") {
      this.$confirm(`${this.$t(message)}`, content, {
        confirmButtonText: this.$t("button.exitImmediately"),
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        showCancelButton: false,
      }).then(() => {
        this.$actions.setGlobalState({
          logout: true,
        });
      });
    },

    getPluginIdFromPermission(data) {
      let index = data.indexOf("@") + 1;
      let lastIndex = data.lastIndexOf("@");
      return data.substring(index, lastIndex);
    },

    startApp() {
      try {
        start({
          singular: false,
          prefetch: "all",
          sandbox: { experimentalStyleIsolation: true },
          fetch(url, ...args) {
            return window.fetch(url, {
              ...args,
              mode: "cors",
              // credentials: "include"
            });
          },
        });
      } catch (error) {
        // console.log("123", error);
      }
    },

    orgTerminalInit() {
      let customers = globalState.commonData.customer || [];
      let stores =
        globalState.commonData.data.find(
          (item) => item.customer.orgCode == globalState.currentCustomer
        )?.terminals || [];
      if (
        isEmpty(globalState.currentCustomer) &&
        isEmpty(globalState.currentStore)
      ) {
        if (customers.length) {
          this.$actions.setGlobalState({
            currentCustomer: customers[0].orgCode,
          });
        }
        let customerStores =
          globalState.commonData.data.find(
            (item) => item.customer.orgCode == globalState.currentCustomer
          )?.terminals || [];
        if (customerStores.length) {
          this.$actions.setGlobalState({
            currentStore: customerStores[0].terminal,
          });
        }
      } else {
        if (
          !customers.some(
            (item) => item.orgCode === globalState.currentCustomer
          )
        ) {
          this.$actions.setGlobalState({
            currentCustomer: "",
            currentStore: "",
          });
        }
        if (!stores.some((item) => item.terminal == globalState.currentStore)) {
          this.$actions.setGlobalState({
            currentStore: "",
          });
        }
      }
    },
    dealFullScreen() {
      const url = location.pathname + location.hash;
      const reg = /\/full(s|S)creen/;
      if (!reg.test(url)) return false;

      const activeRule = url.split(reg)[0].slice(1);
      return [
        ...this.$store.state.config.apps,
        ...this.$store.state.config.plugins,
      ].some((app) => {
        const _activeRule = Array.isArray(app.activeRule)
          ? app.activeRule
          : [app.activeRule];
        return _activeRule.includes(activeRule);
      });
    },
  },
};
</script>
<style scoped lang="scss">
.base-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 1280px;
  .homeContainer {
    flex: auto;
    overflow: hidden;
  }
}
</style>
